import { PopularButton, PopularTitle, PopularWrapper } from "./style";

export const Popular = () => (
  <PopularWrapper>
    <PopularTitle>
      Vermont Farmhouse With Antique Jail Is the Week's Most Popular Home
    </PopularTitle>
    <PopularButton>Read more</PopularButton>
  </PopularWrapper>
);
